import React from 'react';

import { HintButton } from '@lt/components';
import styled from 'styled-components';
import { TITLE } from './constants';

interface IWhatIncludedInPrice {
  className?: string;
}

const WhatIncludedInPrice: React.FC<IWhatIncludedInPrice> = ({ className }) => (
  <Container className={className}>
    <HintButtonWrapper>
      <HintButton className="lt-icons-hint" as="span" />
    </HintButtonWrapper>
    {TITLE}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const HintButtonWrapper = styled.span`
  margin-right: 5px;
`;

export default WhatIncludedInPrice;
